/** Meta Pixel helpers. Base snippet lives in public/index.html. */
const CURRENCY = 'INR';

/** Never let a blocked/missing pixel throw inside checkout. */
export function fbTrack(event, params) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  try {
    window.fbq('track', event, params);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.warn('[fbq]', event, e);
  }
}

/**
 * Purchase, deduped on a stable order key (Razorpay payment id).
 * Survives refresh, back-navigation and StrictMode double-effects.
 */
export function fbTrackPurchaseOnce(key, value, extra = {}) {
  if (!key) return;
  const storeKey = `rp_fbq_purchase_${key}`;
  try {
    if (localStorage.getItem(storeKey)) return;
    localStorage.setItem(storeKey, String(Date.now()));
  } catch (e) {
    /* private mode: fall through and fire once for this page load */
  }
  fbTrack('Purchase', { value: Number(value) || 0, currency: CURRENCY, ...extra });
}

export { CURRENCY };
